export const shipmentStatus = [
  {
    title: 'Invalid',
    value: 'INVALID'
  },
  {
    title: 'Saved',
    value: 'SAVED'
  },
  {
    title: 'Rated',
    value: 'RATED'
  },
  {
    title: 'Committed',
    value: 'COMMITTED'
  },
  {
    title: 'Auto Tendering',
    value: 'AUTO_TENDERING'
  },
  {
    title: 'Ready To Tender',
    value: 'READY_TO_TENDER'
  }
];

export const ShipmentTypes = [
  { title: 'HC - None', value: 'NONE' },
  { title: 'HC - LTL', value: 'LTL' },
  { title: 'HC - Volume LTL', value: 'VOLUME_LTL' },
  { title: 'HC - Truck Load', value: 'TRUCK_LOAD' },
  { title: 'HC - Parcel', value: 'PARCEL' }
];

export const ShipmentDirection = [
  { title: 'HC - Invalid', value: 'INVALID' },
  { title: 'HC - Outbound', value: 'OUTBOUND' },
  { title: 'HC - Inbound', value: 'INBOUND' },
  { title: 'HC - Drop', value: 'DROP' },
  { title: 'HC - Shuttle', value: 'SHUTTLE' }
];
export const Quantities = quantities => {
  const totalQuantity = quantities || 100;
  const dropDown = [...Array(totalQuantity)];

  return dropDown.map((_item, index) => ({
    title: index + 1,
    value: parseInt(index + 1)
  }));
};

export const US_STATES = [
  {
    value: 'AK',
    title: 'AK'
  },
  {
    value: 'AL',
    title: 'AL'
  },
  {
    value: 'AR',
    title: 'AR'
  },
  {
    value: 'AZ',
    title: 'AZ'
  },
  {
    value: 'CA',
    title: 'CA'
  },
  {
    value: 'CO',
    title: 'CO'
  },
  {
    value: 'CT',
    title: 'CT'
  },
  {
    value: 'DC',
    title: 'DC'
  },
  {
    value: 'DE',
    title: 'DE'
  },
  {
    value: 'FL',
    title: 'FL'
  },
  {
    value: 'GA',
    title: 'GA'
  },
  {
    value: 'HI',
    title: 'HI'
  },
  {
    value: 'IA',
    title: 'IA'
  },
  {
    value: 'ID',
    title: 'ID'
  },
  {
    value: 'IL',
    title: 'IL'
  },
  {
    value: 'IN',
    title: 'IN'
  },
  {
    value: 'KS',
    title: 'KS'
  },
  {
    value: 'KY',
    title: 'KY'
  },
  {
    value: 'LA',
    title: 'LA'
  },
  {
    value: 'MA',
    title: 'MA'
  },
  {
    value: 'MD',
    title: 'MD'
  },
  {
    value: 'ME',
    title: 'ME'
  },
  {
    value: 'MI',
    title: 'MI'
  },
  {
    value: 'MN',
    title: 'MN'
  },
  {
    value: 'MO',
    title: 'MO'
  },
  {
    value: 'MS',
    title: 'MS'
  },
  {
    value: 'MT',
    title: 'MT'
  },
  {
    value: 'NC',
    title: 'NC'
  },
  {
    value: 'ND',
    title: 'ND'
  },
  {
    value: 'NE',
    title: 'NE'
  },
  {
    value: 'NH',
    title: 'NH'
  },
  {
    value: 'NJ',
    title: 'NJ'
  },
  {
    value: 'NM',
    title: 'NM'
  },
  {
    value: 'NV',
    title: 'NV'
  },
  {
    value: 'NY',
    title: 'NY'
  },
  {
    value: 'OH',
    title: 'OH'
  },
  {
    value: 'OK',
    title: 'OK'
  },
  {
    value: 'OR',
    title: 'OR'
  },
  {
    value: 'PA',
    title: 'PA'
  },
  {
    value: 'RI',
    title: 'RI'
  },
  {
    value: 'SC',
    title: 'SC'
  },
  {
    value: 'SD',
    title: 'SD'
  },
  {
    value: 'TN',
    title: 'TN'
  },
  {
    value: 'TX',
    title: 'TX'
  },
  {
    value: 'UT',
    title: 'UT'
  },
  {
    value: 'VA',
    title: 'VA'
  },
  {
    value: 'VT',
    title: 'VT'
  },
  {
    value: 'WA',
    title: 'WA'
  },
  {
    value: 'WI',
    title: 'WI'
  },
  {
    value: 'WV',
    title: 'WV'
  },
  {
    value: 'WY',
    title: 'WY'
  }
];

export const CA_STATES = [
  {
    value: 'AB',
    title: 'AB'
  },
  {
    value: 'BC',
    title: 'BC'
  },
  {
    value: 'MB',
    title: 'MB'
  },
  {
    value: 'NB',
    title: 'NB'
  },
  {
    value: 'NL',
    title: 'NL'
  },
  {
    value: 'NS',
    title: 'NS'
  },
  {
    value: 'NT',
    title: 'NT'
  },
  {
    value: 'NU',
    title: 'NU'
  },
  {
    value: 'ON',
    title: 'ON'
  },
  {
    value: 'PE',
    title: 'PE'
  },
  {
    value: 'QC',
    title: 'QC'
  },
  {
    value: 'SK',
    title: 'SK'
  },
  {
    value: 'YT',
    title: 'YT'
  }
];

export const MX_STATES = [
  {
    value: 'AGU',
    title: 'AGU'
  },
  {
    value: 'BCN',
    title: 'BCN'
  },
  {
    value: 'BCS',
    title: 'BCS'
  },
  {
    value: 'CAM',
    title: 'CAM'
  },
  {
    value: 'CHP',
    title: 'CHP'
  },
  {
    value: 'CHH',
    title: 'CHH'
  },
  {
    value: 'COA',
    title: 'COA'
  },
  {
    value: 'COL',
    title: 'COL'
  },
  {
    value: 'CMX',
    title: 'CMX'
  },
  {
    value: 'DUR',
    title: 'DUR'
  },
  {
    value: 'GUA',
    title: 'GUA'
  },
  {
    value: 'GRO',
    title: 'GRO'
  },
  {
    value: 'HID',
    title: 'HID'
  },
  {
    value: 'JAL',
    title: 'JAL'
  },
  {
    value: 'MEX',
    title: 'MEX'
  },
  {
    value: 'MIC',
    title: 'MIC'
  },
  {
    value: 'MOR',
    title: 'MOR'
  },
  {
    value: 'NAY',
    title: 'NAY'
  },
  {
    value: 'NLE',
    title: 'NLE'
  },
  {
    value: 'OAX',
    title: 'OAX'
  },
  {
    value: 'PUE',
    title: 'PUE'
  },
  {
    value: 'QUE',
    title: 'QUE'
  },
  {
    value: 'ROO',
    title: 'ROO'
  },
  {
    value: 'SLP',
    title: 'SLP'
  },
  {
    value: 'SIN',
    title: 'SIN'
  },
  {
    value: 'SON',
    title: 'SON'
  },
  {
    value: 'TAB',
    title: 'TAB'
  },
  {
    value: 'TAM',
    title: 'TAM'
  },
  {
    value: 'TLA',
    title: 'TLA'
  },
  {
    value: 'VER',
    title: 'VER'
  },
  {
    value: 'YUC',
    title: 'YUC'
  },
  {
    value: 'ZAC',
    title: 'ZAC'
  }
];

export const STATES = {
  US: [...US_STATES],
  CA: [...CA_STATES],
  MX: [...MX_STATES]
};

export const COUNTRIES = [
  {
    value: 'US',
    title: 'United States'
  },
  {
    value: 'CA',
    title: 'Canada'
  },
  {
    value: 'MX',
    title: 'Mexico'
  }
];
